'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setOrganizer;
function setOrganizer(_ref) {
  var name = _ref.name,
      email = _ref.email;

  var formattedOrganizer = '';
  formattedOrganizer += 'CN=';
  formattedOrganizer += name || 'Organizer';
  formattedOrganizer += email ? ':mailto:' + email : '';

  return formattedOrganizer;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ics-browser/dist/utils/set-organizer.js
// module id = 1609
// module chunks = 1